import { callApi } from '@local_modules/generic/fetch.js'

//
export async function loadAppAccountTrackings (appAccountId) {
  const apiUrl = '/api/pg-financials/data/:appAccountId/pg-trackings'
  const data = await callApi(apiUrl, {
    appAccountId
  })
  console.log('api data', data)

  return data
}
